import { useQuery } from '@apollo/client'
import { FullPageLoader } from '@/components_deprecated'
import { Navigate } from 'react-router'
import styled from 'styled-components'
import { useParam } from '@/utils'
import { ChecklistCard } from '../components/ChecklistCard'
import { CHECKLIST_QUERY } from '../queries'
import type { ChecklistQuery, ChecklistQueryVariables } from '../types.graphql'
import { checklistToChecklistType } from '../util'

const Wrapper = styled.div`
  ${props => props.theme.layout.default};
  .--checkbox-box-checked {
    background-color: ${props => props.theme.colors.gray7};
  }
`

interface ViewChecklistResponseProps {}

export const ViewChecklistResponse: React.JSX.CFC<
  ViewChecklistResponseProps
> = () => {
  const checklistId = useParam('checklistId')

  const { data, loading } = useQuery<ChecklistQuery, ChecklistQueryVariables>(
    CHECKLIST_QUERY,
    {
      variables: { id: checklistId },
    }
  )

  if (loading) return <FullPageLoader />

  if (!data?.checklist) return <Navigate to="/checklists" replace />

  return (
    <Wrapper>
      <ChecklistCard
        viewOnly={true}
        checklist={checklistToChecklistType(data.checklist)}
        mandatory={data.checklist.mandatory}
        onChange={() => {}}
        onSubmit={() => {}}
        removeChecklistFromForm={() => {}}
      />
    </Wrapper>
  )
}
